<template>
  <section>
    <b-row>
      <!-- Col: Patient Details -->
      <b-col cols="12">
        <b-card border-variant="secondary" no-body>
          <b-card-body>
            <b-row>
              <b-col md="2" lg="2"><span class="font-weight-bolder">Patient Details:</span></b-col>
              <b-col md="3" lg="3">
                <span class="font-weight-bold pr-75">Name:</span>
                <span class="font-weight-bold">
                  <span v-if="patientData.first_name">{{ patientData.first_name + " " }}</span>
                  <span v-if="patientData.second_name">{{ patientData.second_name + " " }}</span>
                  <span v-if="patientData.third_name">{{ patientData.third_name + " " }}</span>
                  <span v-if="patientData.forth_name">{{ patientData.forth_name }}</span>
                </span>
              </b-col>
              <b-col md="1" lg="1">
                <span class="font-weight-bold">Age:</span>
                <span class="font-weight-bold"> {{ patientData.age }}</span>
              </b-col>
              <b-col md="2" lg="2">
                <span class="font-weight-bold">Phone:</span>
                <span class="font-weight-bold"> {{ patientData.phone }}</span>
              </b-col>
              <b-col md="3" lg="3">
                <span class="font-weight-bold">Referral:</span>
                <span class="font-weight-bold"> {{ patientData.patient_referred_from }}</span>
              </b-col>
            </b-row>
          </b-card-body>
        </b-card>
      </b-col>
    </b-row>
   
    <b-row v-if="requestPermission.includes('store-destination')">
      <b-col>
        <b-card border-variant="secondary">
          <b-row>
            <b-col>
              <h4>New Assignment :</h4>
              <br />
            </b-col>
          </b-row>
          <b-row>
            <b-col md="4">
              <b-form-group label="Choose Department to Assign" label-for="department">
                <v-select v-model="department" :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'" label="title"
                  :options="departments" placeholder="Department" />
              </b-form-group>
            </b-col>
            <b-col md="4">
              <b-form-group label="Choose a date" label-for="date">
                <b-input-group class="mb-0">
                  <b-form-input class="datebtn2" id="example-input" v-model="dateValue" type="text"
                    placeholder="YYYY-MM-DD" autocomplete="off"></b-form-input>
                  <b-input-group-append class="m-0 p-0 dateBtn">
                    <b-form-datepicker v-model="dateValue" class="m-0 p-0" button-only right locale="en-US"
                      aria-controls="example-input"></b-form-datepicker>
                  </b-input-group-append>
                </b-input-group>
              </b-form-group>
            </b-col>
            <b-col md="4">
              <b-form-group label="Choose a time" label-for="time">
                <b-input-group class="">
                  <b-form-input id="example-input" v-model="timeValue" type="text"
                    placeholder="HH:mm:ss"></b-form-input>
                  <b-input-group-append>
                    <b-form-timepicker v-model="timeValue" button-only right show-seconds locale="en"
                      aria-controls="example-input"></b-form-timepicker>
                  </b-input-group-append>
                </b-input-group>
              </b-form-group>
              <br />
            </b-col>
            <b-col cols="5"></b-col>
            <b-col cols="4">
              <b-button variant="primary assignButton" @click="AssignPatientwithDate()">
                Assign
              </b-button>
            </b-col>
          </b-row>
        </b-card>
      </b-col>
    </b-row>
  </section>
</template>

<script>
import {
  BRow,
  BCol,
  BCard,
  BCardBody,
  BTableLite,
  BCardText,
  BButton,
  BAlert,
  BLink,
  VBToggle,
  BFormInput,
  BTable,
  BMedia,
  BAvatar,
  BBadge,
  BDropdown,
  BDropdownItem,
  BPagination,
  BTooltip,
  BFormGroup,
  BFormSelect,
  BSpinner,
  BModal,
  BFormTags,
  BFormTag,
  BInputGroup,
  BInputGroupAppend,
  BFormDatepicker,
  BFormTimepicker,
  BImg,
} from "bootstrap-vue";
import vSelect from "vue-select";
import router from "@/router";
import Ripple from "vue-ripple-directive";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
import permissionChecker from "@/mixins/permissionChecker";
export default {
  mixins: [permissionChecker],
  components: {
    BRow,
    BCol,
    BCard,
    BCardBody,
    BTableLite,
    BCardText,
    BButton,
    BAlert,
    BLink,
    vSelect,
    BFormInput,
    BTable,
    BMedia,
    BAvatar,
    BBadge,
    BDropdown,
    BDropdownItem,
    BPagination,
    BTooltip,
    BFormGroup,
    BFormSelect,
    BSpinner,
    BModal,
    BFormTags,
    BFormGroup,
    BInputGroup,
    BInputGroupAppend,
    BFormDatepicker,
    BFormTimepicker,
    BImg,
  },
  directives: {
    Ripple,
    "b-toggle": VBToggle,
  },
  data() {
    return {
      patientData: [],
      patientuuid: "1",
      EditForm: {
        first_name: "",
        second_name: "",
        third_name: "",
        forth_name: "",
        first_mother_name: "",
        second_mother_name: "",
        third_mother_name: "",
        forth_mother_name: "",
        national_id: "",
        phone: "",
        second_phone: "",
        age: "",
        adderss: "",
        _method: "PUT",
      },
      loading: true,
      selected: "",
      option: [],
      params: {
        form: {},
        path: "",
      },
      timeValue: "",
      dateValue: "",
      symptom: "",
      symptom2: "",
      symptomList: [],

      options: [
        "Fever",
        "Bone Pain",
        "Weight loss",
        "Fatigue",
        "Pallor",
        "Fit",
        "Bleeding",
      ],
      AssignPatientForm: {
        patient_id: "",
        date: "",
        department_id: "",
      },
      value: [],
      department: "Clinic",
      departments: ["Clinic", "Emergency", "Laboratory", "Pharmacy", "Daily Care",'Consltant'],
    };
  },
  computed: {
    availableOptions() {
      return this.options.filter((opt) => this.value.indexOf(opt) === -1);
    },
  },

  mounted() {
    this.getPatientInfo();
  },
  methods: {
    async getPatientInfo() {
      await this.getPatient(`/patient?filter[uuid]=${router.currentRoute.params.id}`);
      this.patientData = this.all_data.data[0];
      this.loading = false;
    },
    AssignPatientwithDate() {
      this.AssignPatientForm.patient_id = this.patientData.uuid;
      this.AssignPatientForm.date = this.dateValue + " " + this.timeValue;
      this.AssignPatientForm.department_id = (
        this.departments.indexOf(this.department) + 3
      ).toString();
      (this.params.form = this.AssignPatientForm), (this.params.path = "/destination");
      this.$store
        .dispatch("create", this.params)
        .then((response) => {
          this.dateValue = "";
          this.timeValue = "";
          this.$toast({
            component: ToastificationContent,
            position: "top-right",
            props: {
              title: "Assign Completed",
              variant: "success",
              text:
                "This Patient has been assigned to " + this.department + " Department",
            },
          });
        })
        .catch((error) => {
          if (error.response.status === 400) {
            for (let item in error.response.data) {
              this.$toast({
                component: ToastificationContent,
                position: "top-right",
                props: {
                  title: "validation error",
                  variant: "danger",
                  text: error.response.data[item][0],
                },
              });
            }
          }
        });
    },
    reloadPage() {
      window.location.reload();
    },
  },
};
</script>

<style lang="scss" scoped>
.modify-img {
  height: 5rem;
  width: 4rem;
  display: block;
  float: right;
  margin-right: 1rem;
}


.modify-hover:hover {
  box-shadow: rgba(0, 0, 0, 0.35) 0px 5px 15px;
  border: 1px solid #b3b3b3;
}
</style>

<style lang="scss">
@import "@core/scss/vue/libs/vue-select.scss";
</style>
